<template>
    <div class="content-root">
        <cart-nav :options="[ $t('cart_nav.choose_plan'), $t('cart_nav.confirm_details'), $t('cart_nav.complete') ]" :active="cartIndex"></cart-nav>
        <div class="switch-container" v-if="showCom">
            <div v-if= "mode==='switch'" class="switchSuccess">
                <div class="content-top">
                    <h1>{{$t('switch_plan.switch_free_title')}}</h1>
                </div>
                <div class="content-center">
                    <div class="middle-package">
                        <p class="package">{{$t('switch_plan.switch_free_detail')}}</p>
                        <plan-message :list="message" class="plan-message" v-if="message.length > 0"></plan-message>
                    </div>
                    <div class="refund-info" v-if="refundTip">
                        <p>{{$t('switch_plan.refund_info')}}</p>
                    </div>
                    <div class="middle-text">
                        <p v-html="$t('switch_plan.contact_us_switch')"></p>
                    </div>
                </div>
            </div>
            <div v-else class="renewalPlan">
                <div class="word-center">
                    <div class="banner-box">
                        <div class="banner-container">
                            <div class="banner"><i class="icon-icon_have"></i></div>
                            <div class="banner-text">
                                <h1 v-if="mode==='renew'">{{$t('switch_plan.renewal_free')}}</h1>
                                <h1 v-if="mode==='subscribe'">{{$t('switch_plan.open_free')}}</h1>
                            </div>
                        </div>
                    </div>
                    <div class="mobile-padding">
                        <p class="send-email" v-html="$t('switch_plan.contact_us_renew')"></p>
                    </div>
                </div>
            </div>
            <div class="button-box" v-if="config.platform === 'web'">
                <div class="button-box-inner">
                    <router-link to="/user/dashboard/" class="ui-button primary-button">{{$t('nav.dashboard')}}</router-link>
                    <router-link to="/user/cloud-library/" class="ui-button empty-button">{{$t('switch_plan.my_library')}}</router-link>
                    <a :href="$t('dashboard.bind_url')" target="_blank" class="ui-link">
                        <span class="text">{{$t('switch_plan.upload_video')}}</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { orderedProductInfo } from '@/api/plan';
import { timeResolve } from '@/common/js/date';
import { config } from 'CONFIG';
import { payment as paymentStatus } from '@/config/status';
import cartNav from '@/components/cartNav';
import planMessage from '@/components/planMessage';
import { requestToApp } from '@/api/app';
import reolinkGa from '@/common/js/gtagPageview';

export default {

    components: {

        cartNav,
        planMessage

    },
    data () {

        return {

            config,
            dataObj: {},
            freeTip: '',
            refundTip: this.$route.query.refund,
            cartIndex: 2,
            showCom: false,
            mode: this.$route.query.mode

        };

    },

    created () {

        this._orderedProductInfo();
        reolinkGa.sendSubscribeMode();

    },

    methods: {
        timeFormat ( time ) {

            let {

                year,
                month,
                dateOfMonth,
                hour

            } = timeResolve( time );

            return [
                `${month}/${dateOfMonth}/${year} ${hour}:00`,
                `${dateOfMonth}/${month}/${year} ${hour}:00`
            ];

        },
        _orderedProductInfo () {

            orderedProductInfo().then( res => {

                this.dataObj = res;
                this.dataObj.startedTime = res.cycle.startedAt;
                this.dataObj.expiredTime = res.cycle.endingAt;
                this.dataObj.title = res.plan.title;
                this.freeTip = res.plan.cycle.standard.salePrice;
                this.dataObj.unit = res.plan.cycle.standard.interval.unit;
                this.dataObj.frequency = res.plan.cycle.standard.interval.frequency;
                this.showCom = true;

                if ( config.platform === 'app' ) {

                    requestToApp( 'updatePaymentStatus', {

                        status: paymentStatus.COMPLETED

                    });

                }

            }).catch( err => {

                console.error( err );
                
            });
            
        }
    },

    computed: {

        message () {

            let title = this.dataObj.title;
            let unit = this.dataObj.unit;
            let frequency = this.dataObj.frequency;
            let startedTime = this.dataObj.startedTime;
            let expiredTime = this.dataObj.expiredTime;
            let result = [
                {
                    label: this.$t( 'switch_plan.plan_name' ),
                    texts: [
                        `${title} (${this.$tc( `cycle.${unit}`, frequency, {

                            count: frequency

                        })})`
                    ],
                    red: true
                },
                {
                    label: this.$t( 'switch_plan.vaild_time' ),
                    texts: [

                        this.$t( 'date_resolve.date_res', {

                            en_date: this.timeFormat( startedTime )[0] + '-' + this.timeFormat( expiredTime )[0],
                            de_date: this.timeFormat( startedTime )[1] + '-' + this.timeFormat( expiredTime )[1]

                        })
                    ]
                }
            ];

            if ( this.freeTip === '0.00' ) {
                    
                result[1].texts.push( this.$t( 'switch_plan.free_tip' ));

            }

            return result;

        }

    }

};
</script>

<style lang='less' scoped>
    .content-root {
        background-color:#F7F8F9;
        padding: 0.6rem 0;
        .switch-container{
            margin: auto;
            max-width: 1200px;
            border:solid 0.01rem #fff;
            border-radius: 0.2rem;
            background-color:#fff;
        }
        .content-top {
            text-align: center;
            h1 {
                margin: 0.6rem 0 0.4rem 0;
                font-weight: 700;
                font-size: 0.36rem;
                color: #333;
            }
        }
        .content-center {
            max-width:760px;
            margin:0 auto;
        }
        .package {
            font-weight: 700;
            font-size: 0.2rem;
            margin-bottom: 0.2rem;
        }
        .middle-package{
            padding-bottom: 0.25rem;
            border-bottom:solid 0.01rem #DDDDDD;
        }
        .refund-info{
            margin-top:0.25rem;
            p{
                font-size: 0.16rem;
                font-weight: 500;
            }
        }
        .middle-text {
            margin-top: 0.1rem;
            margin-bottom: 0.35rem;
            p {
                color: #333;
                font-size: 0.16rem;
                font-weight: 400;
                a {
                    color: @theme;
                    cursor: pointer;
                }
            }
        }
        .renewalPlan {
            .word-center {
                margin: 0 auto;
                max-width: 600px;
                h1 {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #333333;
                }
            }
            .mobile-padding {
                padding: 0 0;
                .send-email {
                    font-weight: 400;
                    margin: 0.25rem 0;
                    color: #666;
                    font-size: 0.16rem;
                    a {
                        color: @theme;
                        cursor: pointer;
                    }
                }
            }
        
        }
        .button-box {
            padding: 0.35rem 0 1.2rem 0;
            // max-width: 600px;
            margin: auto;
            text-align: center;
            .button-box-inner{
                display: inline-block;
                a+a{
                    margin-top: 0.2rem;
                }
                &>a{
                    display: block;
                }
            }
        }
        .banner-container {
            .banner{
                display: none;
            }
            .banner-text{
                margin-top:0.6rem;
            }
        }

    }

@media @mobile {
    .content-root {
        background-color:#fff;
        padding: 0;
        .content-top {
            text-align: center;
            h1 {
                margin: 1rem 0 0.6rem 0;
                font-weight: 500;
                font-size: 0.64rem;
                color: #333;
            }
        }

        .content-center {
            padding: 0 15px;
        }
        .package {
            font-weight: 500;
            font-size: 0.36rem;
            margin-bottom: 0.3rem;
        }
        .middle-package{
            padding-bottom: 0.44rem;
            border-bottom:none;
        }
        .refund-info{
            margin-top:0;
            p{
                font-size: 0.32rem;
                font-weight: 500;
            }
        }
        .middle-text {
            margin-top: 0.2rem;
            p {
                color: #333;
                font-size: 0.24rem;
                font-weight: 400;
                a {
                    color: @theme;
                    cursor: pointer;
                }
            }
        }
        @linear-background: linear-gradient(90deg,@theme-linear-gradient-start,@theme-linear-gradient-end);
        .banner-box {
            background: @linear-background;
            height: 3.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .banner-container {
            display: block;
            width: 6rem;
            .banner {
                width: 0.8rem;
                height: 0.8rem;
                margin: 0 auto;
                padding-bottom: 0.3rem;
                display: block;
                .icon-icon_have {
                    display: block;
                    font-size: 0.8rem;
                    color: #fff;
                }
            }
            .banner-text {
                height: 0.85rem;
                text-align: center;
                margin-top:0.3rem;
                h1 {
                    font-size: 0.36rem;
                    font-weight: 500;
                    width: 5.5rem;
                    color: #fff;
                    margin: 0 auto;
                }
            }
        }
        .renewalPlan .word-center {
            max-width: 1200px;
            .mobile-padding {
                padding: 0 15px;
                .send-email {
                    font-size: 0.28rem;
                    margin: 0.6rem 0 0.8rem 0;
                    span {
                        color: @theme;
                    }
                }
            }
        }
        .button-box {
            margin-bottom: 1.2rem;
            margin-top: 0.6rem;
            padding: 0 15px;
            .button-box-inner{
                display: block;
                &>a{
                    width:100%;
                    padding: 0;
                }
                a+a{
                    margin-top: 0.2rem;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/switchSuccess/index.vue